
import commonMixin from './_common';

/**
 * microCMSmixin
 */
export default {
    data() {
        return {
        };
    },
    mixins: [
        commonMixin,
    ],
    methods: {
        // microCMSコンテンツを取得する
        getMicrocmsContents: async function (endpoint, contentsNum = null, order = 'desc') {
            try {
                this.$_loading();
                const response = await axios.post('/get_microcms_contents', {
                    _method: 'GET',
                    end_point: endpoint,
                    contents_num: contentsNum,
                    order: order,
                });
                if (response.data.status === 'OK') {
                    return response.data.data;
                }
            } finally {
                this.$_unloading();
            }
        },
    }
};
